import { useEffect, useRef } from "react";

export const Starfield = () => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    let w, h, raf;
    const mouse = { x: 0, y: 0 };
    const stars = Array.from({ length: 220 }, () => ({ x: Math.random(), y: Math.random(), z: Math.random() * 0.9 + 0.1, t: Math.random() * 6 }));
    const resize = () => { w = c.width = window.innerWidth; h = c.height = window.innerHeight; };
    const onMove = (e) => { mouse.x = e.clientX / w - 0.5; mouse.y = e.clientY / h - 0.5; };
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      const sy = window.scrollY * 0.05;
      for (const s of stars) {
        s.t += 0.02;
        const x = ((s.x * w - mouse.x * 30 * s.z) % w + w) % w;
        const y = ((s.y * h - mouse.y * 30 * s.z - sy * s.z) % h + h) % h;
        ctx.globalAlpha = (0.4 + Math.sin(s.t) * 0.3) * s.z;
        ctx.fillStyle = s.z > 0.85 ? "#39FF14" : "#cfe3ff";
        ctx.fillRect(x, y, s.z * 1.6, s.z * 1.6);
      }
      raf = requestAnimationFrame(draw);
    };
    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);
  return (
    <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
      <div className="absolute inset-0" style={{ background: "radial-gradient(1200px 700px at 80% -10%, rgba(59,130,246,0.22), transparent 60%), radial-gradient(900px 600px at -10% 40%, rgba(57,255,20,0.08), transparent 60%), #030712" }} />
      <canvas ref={ref} className="absolute inset-0" />
    </div>
  );
};
